module.exports = __webpack_public_path__ + "static/media/why_ar.831aa2f5.vtt";